module.exports = __webpack_public_path__ + "static/media/CottonIcon.3f405a03.svg";